import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import UserRoles from "constants/UserRoles";


const breadcrumbsStatic = [{
	name: 'Financials',
	url: '/financials/logs',
	icon: 'dashboard',
}];

export default class PendingFinancials extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>

				<Collections.LogsFinancials
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={this.props.roles.includes(UserRoles.Admin)}
				/>

				<hr/>

			</div>
		);
	}
}


